import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import cookies from "js-cookie";
import { LangaugeStyleWrapper } from "./languageSwitcher.style";
import { Button } from "primereact/button";
import ReactCountryFlag from "./CountryFlag";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";

const languages = [
  {
    code: "ar",
    name: "Arabic",
    native: "العربية",
    dir: "rtl",
    country_code: "sa",
  },
  {
    code: "en",
    name: "English",
    native: "World Wide",
    country_code: "us",
    dir: "ltr",
  },
];


const GlobeIcon = ({ width = 24, height = 24, color = "#6B47F5" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      opacity="0.25"
      cx="8.2497"
      cy="8.49999"
      rx="2.66667"
      ry="6.66667"
      transform="rotate(-90 8.2497 8.49999)"
      fill="url(#paint0_linear_717_80644)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.36905 6.63824C2.66071 6.45631 2.99142 6.29357 3.34996 6.15015C3.92959 5.9183 4.60239 5.72883 5.34064 5.59095C5.47852 4.8527 5.66799 4.1799 5.89984 3.60027C6.04326 3.24173 6.20599 2.91102 6.38793 2.61936C4.47955 3.22298 2.97267 4.72987 2.36905 6.63824ZM8.2497 1.33334C4.29166 1.33334 1.08303 4.54197 1.08303 8.50001C1.08303 12.4581 4.29166 15.6667 8.2497 15.6667C12.2077 15.6667 15.4164 12.4581 15.4164 8.50001C15.4164 4.54197 12.2077 1.33334 8.2497 1.33334ZM8.2497 2.33334C8.06329 2.33334 7.83512 2.42573 7.57499 2.7008C7.31386 2.97692 7.05566 3.40331 6.82832 3.97166C6.65769 4.39824 6.50996 4.89088 6.39206 5.43501C6.98555 5.36852 7.60865 5.33334 8.2497 5.33334C8.89074 5.33334 9.51384 5.36852 10.1073 5.43501C9.98943 4.89088 9.84171 4.39824 9.67108 3.97166C9.44374 3.40331 9.18554 2.97692 8.92441 2.7008C8.66427 2.42573 8.4361 2.33334 8.2497 2.33334ZM11.1588 5.59095C11.0209 4.8527 10.8314 4.1799 10.5996 3.60027C10.4561 3.24173 10.2934 2.91103 10.1115 2.61936C12.0198 3.22298 13.5267 4.72986 14.1303 6.63824C13.8387 6.45631 13.508 6.29357 13.1494 6.15015C12.5698 5.9183 11.897 5.72883 11.1588 5.59095ZM10.2855 6.4642C9.64913 6.37971 8.96473 6.33334 8.2497 6.33334C7.53466 6.33334 6.85027 6.37971 6.21389 6.4642C6.12939 7.10058 6.08303 7.78497 6.08303 8.50001C6.08303 9.21505 6.12939 9.89944 6.21389 10.5358C6.85027 10.6203 7.53466 10.6667 8.2497 10.6667C8.96473 10.6667 9.64913 10.6203 10.2855 10.5358C10.37 9.89944 10.4164 9.21505 10.4164 8.50001C10.4164 7.78497 10.37 7.10058 10.2855 6.4642ZM11.3147 10.3576C11.3812 9.76415 11.4164 9.14106 11.4164 8.50001C11.4164 7.85896 11.3812 7.23587 11.3147 6.64237C11.8588 6.76028 12.3515 6.908 12.778 7.07863C13.3464 7.30597 13.7728 7.56417 14.0489 7.8253C14.324 8.08543 14.4164 8.3136 14.4164 8.50001C14.4164 8.68642 14.324 8.91459 14.0489 9.17472C13.7728 9.43585 13.3464 9.69405 12.778 9.92139C12.3515 10.092 11.8588 10.2397 11.3147 10.3576ZM10.1073 11.565C9.51384 11.6315 8.89074 11.6667 8.2497 11.6667C7.60865 11.6667 6.98555 11.6315 6.39206 11.565C6.50996 12.1091 6.65769 12.6018 6.82832 13.0284C7.05566 13.5967 7.31386 14.0231 7.57499 14.2992C7.83512 14.5743 8.06329 14.6667 8.2497 14.6667C8.4361 14.6667 8.66427 14.5743 8.92441 14.2992C9.18554 14.0231 9.44374 13.5967 9.67108 13.0284C9.84171 12.6018 9.98943 12.1091 10.1073 11.565ZM10.1115 14.3807C10.2934 14.089 10.4561 13.7583 10.5996 13.3998C10.8314 12.8201 11.0209 12.1473 11.1588 11.4091C11.897 11.2712 12.5698 11.0817 13.1494 10.8499C13.508 10.7065 13.8387 10.5437 14.1303 10.3618C13.5267 12.2702 12.0198 13.777 10.1115 14.3807ZM6.38793 14.3807C4.47955 13.777 2.97267 12.2702 2.36905 10.3618C2.66071 10.5437 2.99142 10.7065 3.34996 10.8499C3.92959 11.0817 4.60239 11.2712 5.34064 11.4091C5.47852 12.1473 5.66799 12.8201 5.89984 13.3998C6.04326 13.7583 6.20599 14.089 6.38793 14.3807ZM5.1847 10.3576C4.64057 10.2397 4.14792 10.092 3.72135 9.92139C3.153 9.69405 2.72661 9.43585 2.45048 9.17472C2.17542 8.91459 2.08303 8.68642 2.08303 8.50001C2.08303 8.3136 2.17542 8.08543 2.45048 7.8253C2.72661 7.56417 3.153 7.30597 3.72135 7.07863C4.14792 6.908 4.64057 6.76028 5.1847 6.64237C5.11821 7.23587 5.08303 7.85896 5.08303 8.50001C5.08303 9.14106 5.11821 9.76416 5.1847 10.3576Z"
      fill="url(#paint1_linear_717_80644)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_717_80644"
        x1="6.89585"
        y1="14.0698"
        x2="25.8498"
        y2="5.67255"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={color} />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_717_80644"
        x1="4.61124"
        y1="14.4876"
        x2="31.9771"
        y2="-15.8226"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={color} />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const LanguageCard = ({ inEnglish, native, className, code, countryCode, onClick, isActive }) => {
  return (
    <div
      className={`lang-card ${className ? className : ""} ${isActive ? "lang-selected" : ""}`}
      onClick={() => onClick(code)}
    >
      <div className="left-part">
        <div className="lang-english">{inEnglish}</div>
        <div className="lang-native">{native}</div>
      </div>
      <div className="right-part">
        <div className="lang-flag">
          <ReactCountryFlag countryCode={countryCode && countryCode.toUpperCase()} svg />
        </div>
      </div>
    </div>
  );
};

const LanguageSwitcher = (props) => {
  const languageSwitchRef = useRef();
  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  const { i18n } = useTranslation();
  const { businessLine } = useParams();

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF;
  else if (businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC;
  else if (businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID;
  else if (businessLine === BUSINESS_LINE_PATHS.CARTRUST)
    businessColor = BUSINESS_LINE_COLORS.CARTRUST;
  else if (businessLine === BUSINESS_LINE_PATHS.SYARAH) businessColor = BUSINESS_LINE_COLORS.SYARAH;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.ALNAGHI) businessColor = BUSINESS_LINE_COLORS.ALNAGHI;
  if (businessLine === BUSINESS_LINE_PATHS.LEAN) businessColor = BUSINESS_LINE_COLORS.LEAN;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.PETROMIN)
    businessColor = BUSINESS_LINE_COLORS.PETROMIN;

  const [ShowLanguageMenu, toggleLanguageMenu] = useState(false);
  // const handleLanguageDropdown=()=>{
  //     ////     // console.log("handleLanguageDropdown");
  // }
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        ShowLanguageMenu &&
        languageSwitchRef.current &&
        !languageSwitchRef.current.contains(e.target)
      ) {
        toggleLanguageMenu(false);
        if (props.setIsShowDialog) props.setIsShowDialog(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [ShowLanguageMenu]);

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [currentLanguage, i18n]);

  return (
    <LangaugeStyleWrapper>
      <div className="language-select" ref={languageSwitchRef}>
        <div className="d-flex justify-content-end align-items-center language-select-root position-relative">
          <Button
            type="button"
            className="language-button p-button-link"
            onClick={() => {
              if (props.setIsShowDialog) props.setIsShowDialog(!ShowLanguageMenu);
              toggleLanguageMenu(!ShowLanguageMenu);
              if (props.setIsInfoBtnExpanded) props.setIsInfoBtnExpanded(false);
            }}
          >
            <span className="languageLabel">{currentLanguageCode.toUpperCase()}</span>
            {!props.hideIcon && <GlobeIcon color={businessColor} />}
            <i className={ShowLanguageMenu ? "pi pi-chevron-up" : "pi pi-chevron-down"}></i>
          </Button>

          {ShowLanguageMenu && (
            <div
              className={`lang-menu ${currentLanguage.dir === "rtl" ? "text-end" : "text-start"}`}
            >
              <div className="suggested-lang">
                <div className="lang-heading">{i18n.t("LEFTFOOTER.SuggestedLanguage")}</div>
                <div className="row g-3" onClick={(e) => e.stopPropagation()}>
                  {languages.map((lang, index) => (
                    <div key={`lang-${index}`} className="col-md-6">
                      <LanguageCard
                        isActive={lang.code === currentLanguageCode}
                        onClick={(code) => {
                          if (props.setIsShowDialog) props.setIsShowDialog(false);
                          i18next.changeLanguage(code);
                          toggleLanguageMenu(false);
                        }}
                        code={lang.code}
                        inEnglish={lang.name}
                        native={lang.native}
                        countryCode={lang.country_code}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </LangaugeStyleWrapper>
  );
};

export default LanguageSwitcher;
